export interface DisplayMessageProvider extends ng.IServiceProvider {
    setHomeState: (state: string) => void;
    setDisplayMessageState: (state: string) => void;
    $get: any;
}

export interface DisplayMessageService {
    homeState: string;
    displayMessageState;
    display: (header: string, message: string) => void;
}

/**\
 * @ngdoc service
 * @name phoenix.displayMessage.pxDisplayMessageServiceProvider
 * @description
 * An Angular provider that is used to configure the target states
 * that the displayMessageService will use to navigate to the `displayMessage`
 * component and the home page.
 */
export function DisplayMessageProvider(): DisplayMessageProvider {
    let targetState: string = '';
    let homeButtonState: string = '';

    return {
        /**
         * @ngdoc method
         * @name pxDisplayMessageServiceProvider#setHomeState
         * @methodOf phoenix.displayMessage.pxDisplayMessageServiceProvider
         * @kind method
         *
         * @description
         * Set the target state that the display message will navigate to when
         * the "home" button is clicked.
         */
        setHomeState: (state: string) => homeButtonState = state,

        /**
         * @ngdoc method
         * @name pxDisplayMessageServiceProvider#setDisplayMessageState
         * @methodOf phoenix.displayMessage.pxDisplayMessageServiceProvider
         * @kind method
         *
         * @description
         * Set the state that is used to display the display message component.
         */
        setDisplayMessageState: (state: string) => targetState = state,
        $get: ['$state', (router: any) => {
            if (!targetState) {
                throw new Error('Must provide a state that will be used to access the display message component');
            }

            return DisplayMessageService(router, {
                displayMessage: targetState,
                home: homeButtonState
            });
        }]
    };
}

/**
 * @ngdoc service
 * @name phoenix.displayMessage.pxDisplayMessageService
 * @description
 * Exposes methods for navigating to and from the display message component. The
 * component uses the `homeState` property for its template's home button.
 */
function DisplayMessageService(state: any, states: { displayMessage: string, home: string }): DisplayMessageService {

    return {
        /**
         * @ngdoc property
         * @name pxDisplayMessageService#homeState
         * @propertyOf phoenix.displayMessage.pxDisplayMessageService
         * @kind property
         *
         * @description
         * A readonly property that returns the target "home" state that should have
         * been configured by the displayMessageServiceProvider.
         */
        get homeState() { return states.home; },

        /**
         * @ngdoc property
         * @name pxDisplayMessageService#displayMessageState
         * @propertyOf phoenix.displayMessage.pxDisplayMessageService
         * @kind property
         *
         * @description
         * A readonly property that returns the target state for dislaying the display
         * message component that should have been configured by the displayMessageServiceProvider
         */
        get displayMessageState() { return states.displayMessage; },

        /**
         * @ngdoc method
         * @name pxDisplayMessageService#display
         * @methodOf phoenix.displayMessage.pxDisplayMessageService
         * @kind method
         *
         * @description
         * Navigate to the display message component and display the provided header and message.
         *
         * @param {String} header The header to display.
         * @param {String} message The message to display.
         */
        display: displayMessage

    };

    function displayMessage(header:string, message: string) {
        state.go(states.displayMessage, { header, message });
    }

}


// WEBPACK FOOTER //
// ./src/phoenix/services/displayMessageService.ts